"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookShareButton = FacebookShareButton;
const jsx_runtime_1 = require("react/jsx-runtime");
// import { transparentize } from 'polished'
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = require("../index");
function FacebookShareButton({ withText, className }) {
    const FBShare = () => {
        if (typeof FB !== 'undefined') {
            FB === null || FB === void 0 ? void 0 : FB.ui({
                // @ts-ignore
                method: 'share',
                href: window.location.href,
            }, null);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(FacebookButton, { className: className, size: "middle", onClick: FBShare, children: [(0, jsx_runtime_1.jsx)(index_1.Icon, { type: "social-facebook", className: withText ? 'm-r-s' : undefined }), withText && (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "share" })] }));
}
const FacebookButton = (0, styled_components_1.default)(index_1.Button) `
	background: ${({ theme }) => theme.color.facebook};
	border-color: ${({ theme }) => theme.color.facebook};

	&:hover {
		background: ${({ theme }) => theme.color.facebook};
	}

	svg {
		width: 16px;
		height: 16px;
	}
`;
